import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Reset scroll on navigation.
 *
 * Storefront pages scroll the window back to the top so a new page starts at
 * the beginning. The staff dashboard is deliberately excluded: its sidebar is
 * pinned and the content area scrolls on its own, so animating the window back
 * to the top there just yanked the view around when a menu item was clicked.
 */
const ScrollTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/staff")) return;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);

  return null;
};

export default ScrollTop;
